// Maps geo region strings → array of SVG path IDs (ISO 3166-1 alpha-2)
export const regionToCountries: Record<string, string[]> = {
  // Europe
  "Western Europe": ["GB","FR","DE","NL","BE","LU","CH","AT","IE","PT","ES"],
  "Northern Europe": ["SE","NO","DK","FI","IS","EE","LV","LT"],
  "Eastern Europe": ["PL","CZ","SK","HU","RO","BG","UA","BY","MD"],
  "Southern Europe": ["IT","GR","HR","RS","BA","SI","MK","AL","ME","XK"],

  // Asia
  "Eastern Asia": ["CN","JP","KR","TW","HK","MO","MN"],
  "Southeast Asia": ["SG","TH","VN","MY","ID","PH","MM","KH","LA","BN","TL"],
  "Southern Asia": ["IN","PK","BD","LK","NP","BT","MV","AF"],
  "Central Asia": ["KZ","UZ","TM","TJ","KG"],
  "Western Asia": ["TR","IL","SA","AE","QA","KW","BH","OM","JO","LB","IQ","IR","SY","YE"],

  // Americas
  "Northern America": ["US","CA","MX"],
  "Central America": ["GT","BZ","SV","HN","NI","CR","PA"],
  "Caribbean": ["CU","JM","HT","DO","PR","TT","BB","LC","VC","GD","AG","DM","KN"],
  "South America": ["BR","AR","CL","CO","PE","VE","EC","BO","PY","UY","GY","SR","GF"],

  // Africa
  "Northern Africa": ["MA","DZ","TN","LY","EG","SD"],
  "Western Africa": ["NG","GH","CI","SN","ML","BF","NE","GN","SL","LR","TG","BJ","MR","GM","GW","CV"],
  "Eastern Africa": ["ET","KE","TZ","UG","RW","BI","DJ","ER","SO","SS","MZ","MG","MU","SC","KM"],
  "Central Africa": ["CD","CM","CF","CG","GA","GQ","ST","TD","AO"],
  "Southern Africa": ["ZA","ZM","ZW","BW","NA","SZ","LS","MW"],

  // Oceania
  "Australia and New Zealand": ["AU","NZ","PG","FJ","SB","VU","WS","TO","KI","FM","MH","PW","NR","TV"],

  // Middle East (alternate label from some geo providers)
  "Middle East": ["TR","IL","SA","AE","QA","KW","BH","OM","JO","LB","IQ","IR","SY","YE"],
}

// Reverse map: country code → region string (for O(1) lookup)
export const countryToRegion: Record<string, string> = Object.entries(regionToCountries)
  .reduce((acc, [region, countries]) => {
    countries.forEach(c => { acc[c] = region })
    return acc
  }, {} as Record<string, string>)

